'use client'
import { useEffect, useState } from 'react'
import { sha256 } from '@/lib/utils/sha256'

import Link from 'next/link'

import { setCookie, getCookie } from '@/lib/utils/cookies'

function checkNotificationDismissed(notificationId) {
  const value = getCookie(notificationId)

  return value === 'dismissed'
}

export default function NotificationItem({ notification }) {
  const {
    text: notificationText,
    link: { title: linkTitle, url: linkUrl, target: linkTarget } = {},
  } = notification

  // Generate a unique ID based on the text content so that it re-appends the notification if the text changes
  const notificationId = `notification-` + sha256(notificationText)

  const [hidden, setHidden] = useState(true)

  useEffect(() => {
    setHidden(checkNotificationDismissed(notificationId))
  }, [notificationId])

  const handleDismiss = () => {
    setHidden(true)
    setCookie(notificationId, 'dismissed', 7)
  }

  if (hidden) {
    return null
  }

  return (
    <li className="site-notification @container">
      <div className="flex w-full items-center justify-center gap-m px-s py-xxs">
        <div className="flex min-h-[32px] flex-col items-start gap-s @[560px]:ml-auto @[560px]:flex-row @[560px]:items-center">
          <span className="text-[length:--p-s-size]">{notificationText}</span>

          {linkTitle && linkUrl ? (
            <Link
              href={linkUrl}
              target={linkTarget ?? '_self'}
              className="btn btn--solid btn--xsmall">
              {linkTitle}
            </Link>
          ) : null}
        </div>

        <button onClick={handleDismiss} className="ml-auto self-start @[560px]:self-auto">
          <svg className="aspect-square w-[24px]" aria-hidden="true">
            <use href={`${process.env.NEXT_PUBLIC_SPRITE_PATH}#icon-close`}></use>
          </svg>
        </button>
      </div>
    </li>
  )
}
